// This is to mainly get around a testing issue where the different space causes a failure

export default function normalizeSpaces(value) {
  if (value) {
    return value.replaceAll(String.fromCharCode(8239), String.fromCharCode(32));
  } else {
    return value;
  }
}
